"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryJSONSchema = exports.queryValidator = void 0;
const zod_1 = require("zod");
const queryValidator = (shema) => (value) => {
    try {
        if (typeof value != 'string') {
            return false;
        }
        const parsed = JSON.parse(value);
        const res = shema.safeParse(parsed);
        return res.success;
    }
    catch (err) {
        return false;
    }
};
exports.queryValidator = queryValidator;
const queryJSONSchema = (schema, error) => {
    return zod_1.z
        .custom((0, exports.queryValidator)(schema), error)
        .transform((x) => JSON.parse(x));
};
exports.queryJSONSchema = queryJSONSchema;
//# sourceMappingURL=index.js.map